import { Pagination } from "react-bootstrap";
import { CustomPagination } from "./styled";

export function PaginationList(props: any) {

    let active = props.currentPage || 1;
    let totalItems = props.totalItems ? props.totalItems : 0;
    let totalPage = (totalItems / 24 >> 0) + 1;
    let isPageNumberOutOfRange = false;

    const handlePageChange = (event?: any) => {
        let page = event;
        if (page > totalPage) {
            page = totalPage;
        } else if (page <= 0) {
            page = 1
        }
        props.onPageChange(page);
    }

    const pageNumbers = [...new Array(totalPage)].map((_, index) => {
        const pageNumber = index + 1;
        const isPageNumberFirst = pageNumber === 1;
        const isPageNumberLast = pageNumber === totalPage;
        const isCurrentPageWithinRange = Math.abs(pageNumber - active) <= 9;
    
        if ( isPageNumberFirst || isPageNumberLast || isCurrentPageWithinRange) {
         isPageNumberOutOfRange = false;
          return (
            <Pagination.Item
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              active={pageNumber === active}
            >
              {pageNumber}
            </Pagination.Item>
          );
        }
    
        if (!isPageNumberOutOfRange) {
          isPageNumberOutOfRange = true;
          return <Pagination.Ellipsis key={pageNumber} className="muted" />;
        }
    
        return null;
    })

    return (
        <>
            <CustomPagination>
                <Pagination className="d-flex justify-content-center">
                    <Pagination.First onClick={() => handlePageChange(1)} />
                    <Pagination.Prev onClick={() => handlePageChange(active - 1)} />
                    {pageNumbers}
                    <Pagination.Next onClick={() => handlePageChange(active + 1)} />
                    <Pagination.Last onClick={() => handlePageChange(totalPage)} />
                </Pagination>
            </CustomPagination>
        </>
    )
}